/**
 * 业务系统列定义.
 */

export default {
  code: 200,
  data: {
    items: [
      {
        type: 'method',
        children: null,
        icon: 'edit',
        cssType: '',
        name: '编辑表单',
        leaf: true,
        param: {
          methodName: 'handlEditFormMenu',
        },
      },
      {
        type: 'method',
        children: null,
        icon: 'add',
        cssType: '',
        leaf: true,
        name: '添加组件',
        param: {
          methodName: 'handleAddItemMenu',
        },
      },
      {
        type: 'method',
        children: null,
        icon: 'add',
        cssType: '',
        leaf: true,
        name: '复制添加',
        param: {
          methodName: 'handleAddItemMenuOfCopy',
        },
        enableExp: '{{!!data.selectdFieldName}}',
      },
      {
        type: 'method',
        children: null,
        icon: 'edit',
        cssType: '',
        name: '编辑',
        leaf: true,
        param: {
          methodName: 'handleEditItemMenu',
        },
        enableExp: '{{!!data.selectdFieldName}}',
      },
      {
        type: 'method',
        children: null,
        icon: 'edit',
        cssType: '',
        name: '隐藏',
        leaf: true,
        param: {
          methodName: 'handleHideItemMenu',
        },
        showExp: '{{!!data.selectdFieldName && data.selectedData.visible}}',
      },
      {
        type: 'method',
        children: null,
        icon: 'edit',
        cssType: '',
        name: '显示',
        leaf: true,
        param: {
          methodName: 'handleShowItemMenu',
        },
        showExp: '{{!!data.selectdFieldName && !data.selectedData.visible}}',
      },
      {
        type: 'method',
        children: null,
        icon: 'delete',
        cssType: '',
        name: '删除',
        leaf: true,
        param: {
          methodName: 'handleDeleteRowMenu',
        },
        enableExp: '{{!!data.selectdFieldName}}',
      },
      {
        type: 'method',
        children: null,
        icon: 'edit',
        cssType: '',
        leaf: true,
        name: '预览模式',
        param: {
          methodName: 'handlePreviewSwitchMenu',
        },
        showExp: '{{!data.preViewFlag}}',
      },
      {
        type: 'method',
        children: null,
        icon: 'edit',
        cssType: '',
        name: '设计模式',
        leaf: true,
        param: {
          methodName: 'handlePreviewSwitchMenu',
        },
        showExp: '{{!!data.preViewFlag}}',
      },
      {
        type: 'method',
        icon: 'edit',
        cssType: '',
        leaf: false,
        name: '快捷操作',
        children: [
          {
            type: 'method',
            children: null,
            icon: 'edit',
            cssType: '',
            leaf: true,
            name: '添加分组(标签、分割线)',
            param: {
              methodName: 'shortcutOperateMixinAddGroupLabel',
            },
          },
          {
            type: 'method',
            children: null,
            icon: 'edit',
            cssType: '',
            leaf: true,
            name: '添加虚线换行符',
            param: {
              methodName: 'shortcutOperateMixinAddGroupDashed',
            },
          },
          {
            type: 'method',
            children: null,
            icon: 'edit',
            cssType: '',
            leaf: true,
            name: '添加换行符',
            param: {
              methodName: 'shortcutOperateMixinAddGroupDashedBlank',
            },
          },
          {
            type: 'method',
            children: null,
            icon: 'edit',
            cssType: '',
            leaf: true,
            name: '添加药械闪加',
            param: {
              methodName: 'shortcutOperateMixinAddflashAddMedical',
            },
          },
          {
            type: 'method',
            children: null,
            icon: 'edit',
            cssType: '',
            leaf: true,
            name: '添加竖线分割符',
            param: {
              methodName: 'shortcutOperateMixinAddPartitionErect',
            },
          },
          {
            type: 'method',
            children: null,
            icon: 'edit',
            cssType: '',
            leaf: true,
            name: '添加标签组(panguForm)',
            param: {
              methodName: 'shortcutOperateMixinAddTagForPanguForm',
            },
          },
          {
            type: 'method',
            children: null,
            icon: 'edit',
            cssType: '',
            leaf: true,
            name: '添加分组(panguForm)',
            param: {
              methodName: 'shortcutOperateMixinAddGroupForPanguForm',
            },
          },
          {
            type: 'method',
            children: null,
            icon: 'edit',
            cssType: '',
            leaf: true,
            name: '分组符(mobile)',
            param: {
              methodName: 'shortcutOperateMixinAddGroupSeparator',
            },
          },
          {
            type: 'method',
            children: null,
            icon: 'edit',
            cssType: '',
            leaf: true,
            name: '可点击视图组开始标识(mobile)',
            param: {
              methodName: 'shortcutOperateMixinAddClickGroupStart',
            },
          },
          {
            type: 'method',
            children: null,
            icon: 'edit',
            cssType: '',
            leaf: true,
            name: '可点击视图组结束标识(mobile)',
            param: {
              methodName: 'shortcutOperateMixinAddClickGroupEnd',
            },
          },
          {
            type: 'method',
            children: null,
            icon: 'edit',
            cssType: '',
            leaf: true,
            name: '横线图片(mobile)',
            param: {
              methodName: 'shortcutOperateMixinAddLineImage',
            },
          },
          {
            type: 'method',
            children: null,
            icon: 'edit',
            cssType: '',
            leaf: true,
            name: '换行符(mobile)',
            param: {
              methodName: 'shortcutOperateMixinAddNextLine',
            },
          },
        ],
      },
      {
        type: 'method',
        children: null,
        icon: 'edit',
        cssType: '',
        leaf: true,
        name: '提交',
        param: {
          methodName: 'submitFormData',
        },
      },
    ],
  },
  msg: 'string',
  success: false,
}
